import React from 'react';
import QRCode from 'qrcode.react';
import Barcode from 'react-barcode';
import { Watermark } from 'antd';
import './css/CatIDCard.css';
import CatAvatar from '../components/img/avatars/CatAvatar.png';
import VaccinationStatus from '../components/VaccinationStatus';

const CatIDCard = ({ cat }) => {
  const catInfoUrl = `https://mao-mi.com/c/${cat.id}`;
  const watermarkContent = ['mao-mi.com', cat.unique_id];

  return (
    <Watermark 
      content={watermarkContent}
      font={{
        family: 'Arial',
        color: 'rgba(0, 0, 0, 0.15)',
      }}
      gap={[35, 35]}
      style={{
        zIndex: 11, 
        pointerEvents: 'none',
      }}
      rootClassName="custom-watermark"
    >
      <div className="cat-id-card">
        <div className="row">
          <div className="col-sm-4">
            <div className="avatar-container">
              <img src={cat.photos[0] ? cat.photos[0] : CatAvatar} className="avatar" alt={cat.name} />
              <VaccinationStatus 
                vaccinations={{
                  first: cat.first_vaccination_date,
                  second: cat.second_vaccination_date,
                  third: cat.third_vaccination_date,
                  rabies: cat.rabies_vaccination_date
                }}
                size={30} // Adjusted size to fit better in this new location
              />
            </div>
            <div className='idcard-barcode'><Barcode className="id-barcode" value={cat.unique_id} width={0.9} height={20} displayValue={false} /></div>
          </div>
          <div className="col-sm-8">
            <div className="row">
              <div className="col-sm-6">
                <div className="cat-title">{cat.name}</div>
              </div>
              <div className="col-sm-6">
                <div className='qrcode-container'>
                  <QRCode value={catInfoUrl} size={80} />
                </div>
              </div>
            </div>
            <div className="cat-description">
              <strong>性别:</strong> {cat.sex == 'M' ? '公猫' : '母猫'} <br />
              <strong>品种:</strong> {cat.breed ? `${cat.breed.name_cn} (${cat.breed.name_en})` : 'Unknown'} <br />
              <strong>出生日期:</strong> {cat.birth_date} <br />
              <strong>唯一ID:</strong> {cat.unique_id} <br />
            </div>
          </div>
        </div>
      </div>
    </Watermark>
  );
};

export default CatIDCard;
